import {MatButtonModule, MatCheckboxModule} from '@angular/material';
import {MatToolbarModule} from '@angular/material/toolbar';
import {MatIconModule} from '@angular/material/icon';
import {MatMenuModule} from '@angular/material/menu';
import {MatFormFieldModule} from '@angular/material/form-field';
import {MatInputModule} from '@angular/material/input';
import {MatSelectModule} from '@angular/material/select';
import {MatDatepickerModule} from '@angular/material/datepicker';
import {MatNativeDateModule} from '@angular/material';
import {MatRadioModule} from '@angular/material';
import {MatDialogModule} from '@angular/material';
import {MatCardModule} from '@angular/material/card';
import {MatTableModule} from '@angular/material/table';
import {MatPaginatorModule} from '@angular/material/paginator';
import {MatProgressSpinnerModule} from '@angular/material/progress-spinner';
import {MatSortModule} from '@angular/material/sort';
import {MatAutocompleteModule} from '@angular/material/autocomplete';
import {MatExpansionModule} from '@angular/material/expansion';
import {MatTooltipModule} from '@angular/material/tooltip';
import {MatSnackBarModule} from '@angular/material/snack-bar';




import {NgModule } from '@angular/core';

@NgModule({
  imports: [MatDialogModule , MatExpansionModule,MatAutocompleteModule,MatSortModule,MatProgressSpinnerModule , MatTableModule,MatPaginatorModule,MatCardModule, MatButtonModule, MatRadioModule,MatNativeDateModule,MatDatepickerModule,MatSelectModule, MatInputModule,MatCheckboxModule,MatToolbarModule,MatIconModule,MatMenuModule,MatFormFieldModule,MatTooltipModule,MatSnackBarModule],
  exports: [MatDialogModule ,MatExpansionModule,MatAutocompleteModule, MatSortModule,MatProgressSpinnerModule , MatTableModule, MatPaginatorModule,MatCardModule, MatButtonModule,MatRadioModule,  MatNativeDateModule,MatDatepickerModule,MatSelectModule, MatInputModule,MatCheckboxModule,MatToolbarModule,MatIconModule,MatMenuModule,MatFormFieldModule,MatTooltipModule,MatSnackBarModule]
})
export class MaterialModule { }